import { render, staticRenderFns } from "./EditAttachment.vue?vue&type=template&id=3315a42a&scoped=true&"
import script from "./EditAttachment.vue?vue&type=script&lang=js&"
export * from "./EditAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315a42a",
  null
  
)

export default component.exports